import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
  Zap, Pause, DollarSign, Flag, X, ChevronUp
} from "lucide-react";
import { Button } from "./ui/button";
import { cn } from "../lib/utils";
import { toast } from "sonner";

const actions = [
  { id: "pause", label: "Pause Campaign", icon: Pause, color: "text-red-600 bg-red-50 hover:bg-red-100 border-red-200" },
  { id: "price", label: "Adjust Price", icon: DollarSign, color: "text-emerald-600 bg-emerald-50 hover:bg-emerald-100 border-emerald-200" },
  { id: "flag", label: "Flag Product", icon: Flag, color: "text-amber-600 bg-amber-50 hover:bg-amber-100 border-amber-200" },
];

export default function QuickActions() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleAction = (actionId) => {
    switch (actionId) {
      case "pause":
        navigate("/campaigns-view");
        toast.info("Navigate to Campaigns to pause a campaign");
        break;
      case "price":
        navigate("/smart-pricing");
        toast.info("Navigate to Pricing to adjust prices");
        break;
      case "flag":
        navigate("/products-view");
        toast.info("Navigate to Products to review items");
        break;
      default:
        break;
    }
    setOpen(false);
  };

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50" data-testid="quick-actions">
      {open && (
        <div className="mb-2 flex items-center gap-2 bg-white rounded-xl shadow-lg border border-slate-200 p-1.5 animate-in slide-in-from-bottom-2 duration-200">
          {actions.map((a) => (
            <Button
              key={a.id}
              variant="outline"
              size="sm"
              onClick={() => handleAction(a.id)}
              data-testid={`quick-action-${a.id}`}
              className={cn("gap-1.5 text-xs font-semibold border transition-all", a.color)}
            >
              <a.icon className="w-3.5 h-3.5" />
              {a.label}
            </Button>
          ))}
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setOpen(false)}
            className="h-8 w-8 p-0 text-slate-400 hover:text-slate-600"
          >
            <X className="w-3.5 h-3.5" />
          </Button>
        </div>
      )}
      
      <Button
        onClick={() => setOpen(!open)}
        data-testid="quick-actions-toggle"
        className={cn(
          "mx-auto flex items-center gap-2 rounded-full px-5 h-10 transition-all",
          open 
            ? "bg-zinc-950 text-white shadow-lg" 
            : "backdrop-blur-xl bg-white/70 border border-white/40 shadow-[0_8px_32px_rgba(0,0,0,0.08)] text-zinc-900"
        )}
      >
        {open ? (
          <>
            <ChevronUp className="w-4 h-4" />
            <span className="text-sm font-semibold">Close</span>
          </>
        ) : (
          <>
            <Zap className="w-4 h-4" />
            <span className="text-sm font-semibold">Quick Actions</span>
          </>
        )}
      </Button>
    </div>
  );
}
